import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { useQuery } from "@tanstack/react-query";
import { getImprovementPlanPieChart } from "../api/improvementPlanAPI";

type QueryFnTypeImprofementPlanPieStatus = typeof getImprovementPlanPieChart;

export const useImprovementPlanPieChartStatus = (config?: QueryConfig<QueryFnTypeImprofementPlanPieStatus>) => {
    const filters = useSelector((state: RootState) => state.filters.improvementPlans.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.improvementPlans.filterByCurrentUser ?? false);

    return useQuery<ExtractFnReturnType<QueryFnTypeImprofementPlanPieStatus>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["improvementPlanPieChart", filterByUser, filters],
        queryFn: () => getImprovementPlanPieChart(filters, filterByUser), 
    });
}